// The welcome page's first screen, in each of the ways it is drawn: the rings
// (the default) and the flow board, named side by side in the line under it
// (ViewSwitch). The rings are drawn in a WelcomeFrame, under the page's
// search box. The view picked is kept for the browser tab, so a fresh
// session opens on the rings.
import RingsView from "./RingsView.jsx";

export const WELCOME_VIEWS = [
  { id: "rings", label: "Rings", Body: RingsView },
  { id: "flow", label: "Flow" },
];

export const WELCOME_VIEW_KEY = "origin-welcome-view-v1";
const DEFAULT_VIEW = "rings";
export function readWelcomeView() {
  try {
    const id = globalThis.sessionStorage?.getItem(WELCOME_VIEW_KEY);
    return WELCOME_VIEWS.some((v) => v.id === id) ? id : DEFAULT_VIEW;
  } catch {
    return DEFAULT_VIEW;
  }
}
export function keepWelcomeView(id) {
  try {
    globalThis.sessionStorage?.setItem(WELCOME_VIEW_KEY, id);
  } catch {
    // Not kept past this page: the choice still stands while it is open.
  }
}
